var objectAssign = require('react/lib/Object.assign');
var Route = require('./Route');

/**
 * A <DefaultRoute> component is a special kind of <Route> that
 * renders when its parent matches but none of its siblings do.
 * Only one such route may be used at any given level in the
 * route hierarchy.
 */
function DefaultRoute(props) {
  return Route(
    objectAssign({}, props, {
      path: null,
      isDefault: true
    })
  );
}

module.exports = DefaultRoute;



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-router/modules/components/DefaultRoute.js
 ** module id = 182
 ** module chunks = 0
 **/